export { ONE_YEAR_MS } from "@shared/const";

// Local login route — no external OAuth portal needed
export const getLoginUrl = () => "/login";
